import { createApp } from 'vue';
import { router } from './router';
import App from './App.vue';
import './styles.scss';
import { createPinia } from 'pinia';
import { initSentry } from './sentry';
import { useErrorStore } from './stores/useErrorStore';

const pinia = createPinia();
const app = createApp(App);
app.use(router);
app.use(pinia);
const initialAttempted = window.location.pathname + window.location.search + window.location.hash;

(async () => {
  await initSentry(app, router);

  // NB. set bad URL to be used after Sentry initialised
  const errorStore = useErrorStore();
  errorStore.setAttemptedUrl(initialAttempted);

  await router.isReady();
  app.mount('#app');
})();
